(function () {

  const normalize = (value) =>
  String(value || "")
    .split("/")[0]
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

  const getSelectedColor = () => {
    const checked = document.querySelector(
      'input[type="radio"][name^="Color-"]:checked'
    );
    return checked ? normalize(checked.value) : null;
  };

  const rebuildGrid = (gallery, colorHandle) => {
    const grid = gallery.querySelector("ul.media-gallery__grid");
    if (!grid) return;

    const items = Array.from(grid.querySelectorAll("li[data-media-color]"));

    const visible = items.filter(
      item => item.getAttribute("data-media-color") === colorHandle
    );

    const hidden = items.filter(
      item => item.getAttribute("data-media-color") !== colorHandle
    );

    const frag = document.createDocumentFragment();
    visible.forEach(n => {
      n.style.display = "";
      frag.appendChild(n);
    });

    hidden.forEach(n => {
      n.style.display = "none";
      frag.appendChild(n);
    });

    grid.appendChild(frag);
  };

  const rebuildSlideshow = (gallery, colorHandle) => {
    const slideshow = gallery.querySelector("slideshow-component");
    if (!slideshow) return;

    const slidesContainer = slideshow.querySelector("slideshow-slides");
    if (!slidesContainer) return;

    const allSlides = Array.from(
      slidesContainer.querySelectorAll("slideshow-slide")
    );

    const matchingSlides = allSlides.filter(
      slide => slide.getAttribute("data-media-color") === colorHandle
    );

    if (!matchingSlides.length) return;

    // Remove all slides
    slidesContainer.innerHTML = "";

    // Append only matching slides
    matchingSlides.forEach((slide, index) => {
      slide.style.display = "";
      slide.style.setProperty("--slideshow-timeline", `--slide-${index}`);
      slidesContainer.appendChild(slide);
    });

    // Reset timeline variable count
    const timelineVars = matchingSlides
      .map((_, i) => `--slide-${i}`)
      .join(", ");

    slideshow.style.setProperty("--slideshow-timeline", timelineVars);

    // Reset to first slide
    if (typeof slideshow.select === "function") {
      slideshow.select(0);
    }

    // Rebuild dots
    const controls = slideshow.querySelector(".slideshow-controls__dots");
    if (controls) {
      controls.innerHTML = "";

      matchingSlides.forEach((_, i) => {
        const li = document.createElement("li");
        const btn = document.createElement("button");

        btn.className = "slideshow-control button button-unstyled";
        btn.setAttribute("aria-label", `Slide ${i + 1} of ${matchingSlides.length}`);
        btn.setAttribute("on:click", `/select/${i}`);
        btn.textContent = i + 1;

        if (i === 0) btn.setAttribute("aria-selected", "true");

        li.appendChild(btn);
        controls.appendChild(li);
      });
    }
  };

  const applyFilter = () => {
    const gallery = document.querySelector("media-gallery");
    if (!gallery) return;

    const colorHandle = getSelectedColor();
    if (!colorHandle) return;

    rebuildGrid(gallery, colorHandle);
    rebuildSlideshow(gallery, colorHandle);

    window.dispatchEvent(new Event("resize"));
  };

  const init = () => {
    const variantInput = document.querySelector('input[name="id"]');
    if (!variantInput) return;

    const rerunSoon = () => {
      requestAnimationFrame(() =>
        requestAnimationFrame(applyFilter)
      );
    };

    rerunSoon();

    const observer = new MutationObserver(rerunSoon);
    observer.observe(variantInput, {
      attributes: true,
      attributeFilter: ["value"],
    });

    document.addEventListener("shopify:section:load", rerunSoon);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

})();